import { useEffect } from 'react'
import './App.css'
import Pages from "@/pages/index.jsx"
import { Toaster } from "@/components/ui/sonner"
import { MeetingNotificationProvider } from "@/components/meetings/MeetingNotificationProvider"
import { IncomingVideoRingModal } from "@/components/calls/IncomingVideoRingModal"
import { PendingMeetingsReminderModal } from "@/components/calls/PendingMeetingsReminderModal"
import { LocaleProvider } from "@/contexts/LocaleContext"
import { LanguageAnnouncementProvider } from "@/components/announcements/LanguageAnnouncementProvider"
import { CalendarMeetingReminderModal } from "@/components/agenda/CalendarMeetingReminderModal"
import { ErrorBoundary } from "@/components/common/ErrorBoundary"
import { InstallPrompt } from "@/components/pwa/InstallPrompt"
import { PushNotificationManager } from "@/components/pwa/PushNotificationManager"
import { PerformanceProvider } from "@/contexts/PerformanceContext"
import { VideoRingNotificationsProvider } from "@/contexts/VideoRingNotificationsContext"

function App() {
  // Service worker is now auto-registered by vite-plugin-pwa
  useEffect(() => {
    const updateViewportVars = () => {
      const height = window.visualViewport?.height || window.innerHeight
      const rounded = Math.round(height)
      document.documentElement.style.setProperty('--app-height', `${rounded}px`)
      document.documentElement.style.setProperty('--app-vh', `${rounded * 0.01}px`)
    }

    updateViewportVars()
    window.addEventListener('resize', updateViewportVars)
    window.addEventListener('orientationchange', updateViewportVars)
    window.visualViewport?.addEventListener('resize', updateViewportVars)
    window.visualViewport?.addEventListener('scroll', updateViewportVars)

    return () => {
      window.removeEventListener('resize', updateViewportVars)
      window.removeEventListener('orientationchange', updateViewportVars)
      window.visualViewport?.removeEventListener('resize', updateViewportVars)
      window.visualViewport?.removeEventListener('scroll', updateViewportVars)
    }
  }, [])

  return (
    <LocaleProvider>
      <LanguageAnnouncementProvider>
        <VideoRingNotificationsProvider>
          <MeetingNotificationProvider>
            <Pages />
            <ErrorBoundary>
              <IncomingVideoRingModal />
            </ErrorBoundary>
            {/* Reminder for SDRs to complete overdue meetings */}
            <ErrorBoundary>
              <PendingMeetingsReminderModal />
            </ErrorBoundary>
            <ErrorBoundary>
              <CalendarMeetingReminderModal />
            </ErrorBoundary>
            <Toaster closeButton duration={5000} />
            <InstallPrompt />
            <PushNotificationManager />
          </MeetingNotificationProvider>
        </VideoRingNotificationsProvider>
      </LanguageAnnouncementProvider>
    </LocaleProvider>
  )
}

export default App
